import { useQueries, UseQueryOptions } from '@tanstack/react-query'
import { checklistKeys } from '@core/react-query/features/checklists/checklist'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  ChecklistTemplate,
  IChecklistTemplate,
} from '@core/entities/checklist/ChecklistTemplate'

export const useGetChecklistTemplatesByIds = (
  payload: { projectId: number; templateIds: number[] },
  options?: Pick<
    UseQueryOptions<IChecklistTemplate, RequestErrorType, ChecklistTemplate>,
    'enabled'
  >,
) => {
  return useQueries({
    queries: payload.templateIds.map((templateId) => ({
      ...checklistKeys.templateById({
        templateId,
        projectId: payload.projectId,
      }),
      select: ChecklistTemplate.new,
      ...options,
    })),
  })
}
